import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { IntercomProvider } from "react-use-intercom";
import Login from "./Pages/Public/Login";
import { ProtectedRoute } from "./_helpers/Auth";
import ForgotPassword from "./Pages/Public/ForgotPassword";
import ResetPassword from "./Pages/Public/ResetPassword";
import VerifyEmail from "./Pages/Public/VerifyEmail";
import Register from "./Pages/Public/Register";
import PublicLayout from "./Layout/PublicLayout";
import { Toaster } from "react-hot-toast";
import TalentsRouter from "./Routers/TalentsRouter";
import { PlanningRouter } from "./Routers/PlanningRouter";
import { CompanyRouter } from "./Routers/CompanyRouter";
import { NotesRouter } from "./Routers/NotesRouter";
import { Inscription } from "./Pages/Public/Inscription";
import { ManifestationsRouter } from "./Routers/ManifestationsRouter";
import { ActivitiesRouter } from "./Routers/ActivitiesRouter";
import { InterventionRouter } from "./Routers/InterventionRouter";

const RoutePath = () => {
    const INTERCOM_APP_ID = process.env.INTERCOM_APP_ID;
    const [user, setUser] = useState(null);

    return (
        <IntercomProvider appId={INTERCOM_APP_ID}>
            <BrowserRouter>
                <Routes>
                    <Route element={<PublicLayout />}>
                        <Route path="/" element={<Login setUser={setUser} />} />
                        <Route path="/register" element={<Register />} />
                        <Route
                            path="/enregistrement"
                            element={<Inscription />}
                        />
                        <Route
                            path="/login"
                            element={<Login setUser={setUser} />}
                        />
                        <Route
                            path="/demande-mot-de-passe"
                            element={<ForgotPassword />}
                        />
                        <Route
                            path="/reset_password/:token"
                            element={<ResetPassword />}
                        />
                        <Route
                            path="/verify_email/:token"
                            element={<VerifyEmail />}
                        />
                    </Route>
                    <Route
                        element={
                            <ProtectedRoute user={user} setUser={setUser} />
                        }
                    >
                        <Route path="/talents/*" element={<TalentsRouter />} />
                        <Route path="/company/*" element={<CompanyRouter />} />
                        <Route path="/intervention/*" element={<InterventionRouter />} />
                        <Route
                            path="/manifestation/*"
                            element={<ManifestationsRouter />}
                        />
                        <Route
                            path="/activity/*"
                            element={<ActivitiesRouter />}
                        />
                        <Route
                            path="/notes-de-frais/*"
                            element={<NotesRouter />}
                        />
                        <Route path="/*" element={<PlanningRouter />} />
                    </Route>

                    <Route path="*" element={<div>Not found</div>} />
                </Routes>
            </BrowserRouter>
            <Toaster />
        </IntercomProvider>
    );
};

if (document.getElementById("app")) {
    const Index = ReactDOM.createRoot(document.getElementById("app"));

    Index.render(<RoutePath />);
}
